import React, { useState, useEffect } from "react";
import CustomTable from "../../../customComponents/CustomTable";
import viewIcon from "./../../../../Assets/icons/eye 1.svg";
import editIcon from "./../../../../Assets/icons/Un-Checkbox.svg";
import download from "./../../../../Assets/icons/download.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import Loader from "../../../customComponents/CustomLoader";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import "./ManageOrder.scss";
import * as base64 from "base-64";

const ManageOrderList = () => {
  const [variantData, setVariantData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchVariantList(newPage);
  };

  const fetchVariantList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/purchaseorder/list",
        {
          orderBy: "po_id desc",
          page,
          pageSize,
          searchText: searchTerm,
           po_item_type: "V"
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        po_type: item.po_type || "- -",
        po_delivery_date: item.po_delivery_date || "--",
        po_expected_date: item.po_expected_date || "--",
        approval_remark: item.approval_remark || "--",
        created_by_name: item.created_by_name || "--",
        updated_by_name: item.updated_by_name || "--",
        // status: item.status === "View VIN" ? "Received" : item.status,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.countdata;
      console.log(response, totalCount, "totalCount");
      setTotalData(totalCount);
      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setVariantData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching variant list:", error);
    } finally {
      setLoading(false);
    }
  };

  const VARIANT_TABLE_HEADERS = [
    "PO No.",
    "PO Date",
    //"PO Type",
    "Order Quantity",
    "Modified Quantity",
    // "Accepted",
    // "Defective",
    "Created By",
    "Role",
    "Updated By",
    "Dealer Expected Date",
    "Revised Expected Date",
    "Total Price",
    "Status",
    // "Remark",
    "Action",
  ];

  const variantKeyMapping = {
    "PO No.": "po_number",
    "PO Date": "po_date",
    Role: "role_name",
    // "PO Type":"po_type",
    "Order Quantity": "orderqty",
    "Modified Quantity": "accepted_qty",
    // "Defective":"defective_qty",
    Status: "status",
    "Dealer Expected Date": "po_dealer_expected_date",
    "Revised Expected Date": "po_delivery_date",
    "Created By": "created_by_name",
    "Updated By": "updated_by_name",
    Remark: "remark",
    "Total Price": "total",
    Action: [
      { type: "view", icon: viewIcon, label: "view" },
      { type: "draftedit", icon: editIcon, label: "Edit" },
      {
        type: "manageorder",
        icon: download,
        label: "Print",
      },
    ],
  };

  // const handleView = (rowData) => {
  //   console.log("rowdata>", rowData);
  //   navigate(`${ROUTES_NAVIGATION.MANAGEORDERDETAILS}`, {
  //     state: { data: rowData },
  //   });
  // };

  const handleView = (rowData) => {
    console.log("rowdata>", rowData);
    if (
      rowData.status === "In Transit" ||
      rowData.status === "Partially Received " ||
      rowData.status === "Partial Delivered" ||
      rowData.status === "Received with Damaged Items Accepted"
    ) {
      navigate(ROUTES_NAVIGATION.INTRANSIT, {
        state: { data: rowData },
      });
    } else {
      navigate(ROUTES_NAVIGATION.MANAGEORDERDETAILS, {
        state: { data: rowData },
      });
    }
  };

  const onEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITGENERATEORDER}`, {
      state: { data: rowData },
    });
  };

  useEffect(() => {
    if (searchTerm === "") {
      fetchVariantList();
    }
  }, [searchTerm]);

  // const DownLoadPdf = (row) => {
  //   var text = row?.po_id;
  //   var encoded = base64.encode(text);
  //   const pdfURL = `${process.env.REACT_APP_API_BASE_URL}dealer/dealer-wise-inovice/${encoded}`;
  //   window.open(pdfURL, "_blank", "noopener,noreferrer");
  // };

  // const DownLoadPdf = (row) => {
  //   var text = row?.po_id;
  //   var encoded = base64.encode(text);
  //   const pdfURL = `${process.env.REACT_APP_API_BASE_URL}dealer/dealer-wise-inovice/${encoded}`;
  //   window.open(pdfURL, "_blank", "noopener,noreferrer");
  // };

  const DownLoadPdf = async (row) => {
    try {
      var text = row?.po_id;
      var encoded = base64.encode(text);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}dealer/dealer-wise-inovice/${encoded}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // if needed
          },
        },
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `dealer_invoice_${row?.po_id}.pdf`; // file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5 className="header-manageOrder">Order Management</h5>
            </div>
            <div className="totalvaluescontainer header-content-manage-order col-xl-6 col-lg-12 mt-2 mb-2">
              <div className="countsVal">
                <div
                  className="totalvaltopleftdataContainerues"
                  style={{
                    borderRight: "1px solid lightgrey",
                    paddingRight: "10px",
                  }}
                >
                  <h5 className="listTopDataValueText">{totalData.total} </h5>
                  <h6 className="titleNameValue">Total Orders</h6>
                </div>
                <div
                  className="topleftdataContainer"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <h5 className="listTopDataValueText">
                    {totalData.total_active}{" "}
                  </h5>
                  <h6 className="titleNameValue">Approved Orders</h6>
                </div>
                <div className="topleftdataContainer">
                  <h5 className="listTopDataValueText">
                    {totalData.total_pending}{" "}
                  </h5>
                  <h6 className="titleNameValue">Pending Orders</h6>
                </div>
                <div className="topleftdataContainer">
                  <h5 className="listTopDataValueText">
                    {totalData.total_inactive}{" "}
                  </h5>
                  <h6 className="titleNameValue">Rejected Orders</h6>
                </div>
              </div>
              <div className="manage-order-heading">
                <div className="order-list-listname">Order Management</div>
                <button
                  className="addcustomerbutton"
                  onClick={() => navigate(ROUTES_NAVIGATION.GENERATEORDER)}
                >
                  Create Order
                </button>
              </div>
            </div>
          </div>
          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Order List</h5>
                <div>
                  <SearchInput
                    placeholder="Search By PO No."
                    onSearch={fetchVariantList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
              </div>
            </div>
            <CustomTable
              data={variantData}
              headers={VARIANT_TABLE_HEADERS}
              keyMapping={variantKeyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              handleViewButton={handleView}
              totalRecords={totalRecords}
              onEdit={onEdit}
              pdfDownLoad={DownLoadPdf}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ManageOrderList;
